import { ChangeDetectorRef, Component, ElementRef, Injectable, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap';
import * as _ from 'lodash';
import { ToastrService } from 'ngx-toastr';
import { TemplateService } from '../../../../../../common/services/Template.service';
import { GroupService } from '../../../../../../common/services/Group.service';
import { PriorityService } from '../../../../../../common/services/Priority.service';
import { TicketService } from '../../../../../../common/services/Ticket.service';
import { FieldService } from '../../../../../../common/services/Field.service';
import { UserService } from '../../../../../../common/services/User.service';
import { AnswerTemplateConst, AnswerTemplateType, AnswerTemplateTypeArr } from './answer-template.const';
import { TableAction } from '../../../../../../components/table-component/table.const';
import { BaseListComponent } from '../../../../../../components/base-list.component';
import { FormFieldType, ModalType } from '../../../../../../components/modals/modal-form-template/modal-form.const';
import { Observable } from 'rxjs';

@Component({
  selector: 'settings-tickets-answer-template',
  templateUrl: './answer-template.component.html',
  styleUrls: ['./answer-template.component.css'],
  providers: [TemplateService, BsModalService, GroupService, FieldService, PriorityService, TicketService, UserService],
})
@Injectable()
export class AnswerTemplateComponent extends BaseListComponent {
  @ViewChild('templateExample') templateExample: ElementRef;
  public accessTypes: any = [{ id: '', text: 'Đối tượng xử dụng' }, ...AnswerTemplateTypeArr];
  public allGroup: any = [];
  public modelFilter: any = {};
  public allPriority: any = [];
  public allStatus: any = [];
  public allfields: any = [];
  public allUser: any = [];
  public is_load_data = false;

  constructor(
    protected changeDetector: ChangeDetectorRef,
    protected toastr: ToastrService,
    protected modalService: BsModalService,
    private templateService: TemplateService,
    private priorityService: PriorityService,
    private ticketService: TicketService,
    private userService: UserService,
    private groupService: GroupService,
    private fieldService: FieldService
  ) {
    super(changeDetector, toastr, modalService);
    this.displayColumns = AnswerTemplateConst.displayColumns();
  }

  async ngOnInit() {
    Observable.forkJoin([
      this.getMyFields(),
      this.getPriorities(),
      this.getStatus(),
      this.getAgents(),
      this.getGroups(),
    ]).subscribe(res => {
      this.loadData();
    });
  }

  async loadData(request: any = {}, sort: any = {}) {
    const payload = await this.buildBasePayload(request, sort);
    this.templateService
      .list(payload)
      .toPromise()
      .then(
        res => {
          if (res.status == 200 && res.error == false) {
            this.data = res.data.templates;
            this.data = this.data.map(res => {
              res.display_access_type = AnswerTemplateConst.displayTypeColumn(res);
              return res;
            });
            this.initPage(res.data.total);
          } else {
            this.throwError();
          }
        },
        error => {
          this.throwError(error.message);
        }
      );
  }

  async search() {
    this.currentPage = 1;
    if (this.modelFilter.keyword && this.modelFilter.keyword.trim() != '') {
      await this.loadData({ filters: this.modelFilter.keyword.trim() });
    } else {
      await this.loadData();
    }
  }

  async setUpModel(type) {
    this.typeModal = type;
    this.modelContent = {
      type: ModalType.Primary,
      title: this.typeModal === 'add' ? 'Thêm mới mẫu ticket' : 'Cập nhật mẫu ticket',
      submit_title: this.typeModal === 'add' ? 'Thêm mới' : 'Cập nhật',
    };
    this.modelDisplay = [
      {
        key: 'name',
        label: 'Tên mẫu ticket',
        type: FormFieldType.Text,
        value: this.model.name,
        required: true,
        disabled: false,
        width: 'full',
        order: 0,
      },
      {
        key: 'access_type',
        label: 'Đối tượng sử dụng',
        type: FormFieldType.Select2,
        value: this.model.access_type,
        required: true,
        disabled: false,
        width:
          this.model.access_type !== AnswerTemplateType.GroupAgent &&
          this.model.access_type !== AnswerTemplateType.Agent
            ? 'full'
            : '1/2',
        order: 1,
        options: {
          data: this.accessTypes,
          select2Options: {
            placeholder: { id: '', text: 'Đối tượng sử dụng' },
          },
        },
      },
    ];
    if (this.model.access_type === AnswerTemplateType.GroupAgent) {
      this.modelDisplay.push({
        key: 'access_ids',
        label: 'Bộ phận',
        type: FormFieldType.Select2,
        value: this.model.access_ids,
        required: true,
        disabled: false,
        width: '1/2',
        order: 2,
        options: {
          data: this.allGroup,
          select2Options: {
            placeholder: { id: '', text: 'Bộ phận' },
            multiple: true,
          },
        },
      });
    } else if (this.model.access_type === AnswerTemplateType.Agent) {
      this.modelDisplay.push({
        key: 'access_ids',
        label: 'Chuyên viên',
        type: FormFieldType.Select2,
        value: this.model.access_ids,
        required: true,
        disabled: false,
        width: '1/2',
        order: 2,
        options: {
          data: this.allUser,
          select2Options: {
            placeholder: { id: '', text: 'Chuyên viên' },
            multiple: true,
          },
        },
      });
    }
    this.modelDisplay = [
      ...this.modelDisplay,
      {
        key: 'line',
        type: FormFieldType.Line,
        order: 3,
      },
      {
        key: 'action_label',
        label: 'Nội dung ticket',
        order: 3,
      },
      {
        key: 'subject',
        label: 'Tiêu đề ticket',
        type: FormFieldType.Text,
        value: this.model.subject,
        required: false,
        disabled: false,
        width: '1/2',
        order: 4,
      },
      {
        key: 'assign',
        label: 'Chuyên viên xử lý',
        type: FormFieldType.Select2,
        value: this.model.assign,
        required: false,
        disabled: false,
        width: '1/2',
        order: 4,
        options: {
          data: [{ id: '-1', text: 'Chọn' }, ...this.allUser],
        },
      },
      {
        key: 'follow',
        label: 'Theo dõi',
        type: FormFieldType.Select2,
        value: this.model.follow,
        required: false,
        disabled: false,
        width: '1/2',
        order: 5,
        options: {
          data: this.allUser,
          select2Options: {
            placeholder: { id: '', text: 'Mặc định' },
            multiple: true,
          },
        },
      },
      {
        key: 'cc',
        label: 'Cc',
        type: FormFieldType.Select2,
        value: this.model.cc,
        required: false,
        disabled: false,
        width: '1/2',
        order: 6,
        options: {
          data: this.allUser,
          select2Options: {
            placeholder: { id: '', text: 'Mặc định' },
            multiple: true,
          },
        },
      },
      {
        key: 'priority',
        label: 'Ưu tiên',
        type: FormFieldType.Select2,
        value: this.model.priority,
        required: false,
        disabled: false,
        width: '1/2',
        order: 7,
        options: {
          data: [{ text: 'Mặc định', id: '-1' }, ...this.allPriority],
        },
      },
      {
        key: 'status',
        label: 'Trạng thái',
        type: FormFieldType.Select2,
        value: this.model.status,
        required: false,
        disabled: false,
        width: '1/2',
        order: 8,
        options: {
          data: [{ text: 'Mặc định', id: '-1' }, ...this.allStatus],
        },
      },
    ];

    if (this.allfields) {
      this.allfields.forEach(element => {
        const renderType = key => {
          switch (key) {
            case 'date':
              return FormFieldType.Datepicker;
              break;
            case 'multi-select':
            case 'select':
              return FormFieldType.Select2;
              break;
            default:
              return key;
              break;
          }
        };

        const Type = renderType(element.type);
        let object = {
          key: element.key,
          label: element.title,
          type: Type,
          value: this.model[`${element.key}`] || null,
          required: element.required,
          disabled: false,
          width: '1/2',
          order: 4,
        };

        if (Type == FormFieldType.Datepicker) {
          object['options'] = {
            dateOptions: {
              dateInputFormat: 'YYYY-MM-DD',
              containerClass: 'theme-blue',
            },
            placement: 'right',
          };
        }

        if (Type == FormFieldType.Select2) {
          object['options'] = {
            data: [
              { text: '--Chọn--', id: '-1' },
              ...element.data.map((value, index) => ({
                id: value.toString(),
                text: value,
              })),
            ],
            multiple: true,
          };
        }

        if (element.type == 'multi-select') {
          object['options'] = {
            data: [
              ...element.data.map((value, index) => ({
                id: value.toString(),
                text: value,
              })),
            ],
            select2Options: {
              placeholder: { text: '--Chọn--', id: '-1' },
              multiple: true,
            },
          };
        }
        this.modelDisplay = [...this.modelDisplay, object];
      });
    }

    this.modelDisplay = [
      ...this.modelDisplay,
      {
        key: 'intro',
        label: 'Comment',
        type: FormFieldType.TextEditor,
        value: this.model.intro,
        required: true,
        disabled: false,
        width: 'full',
        order: 11,
      },
    ];
  }

  async addTemplate(payload) {
    this.templateService.create(payload).subscribe(
      res => {
        if (res.status == 200 && res.error == false) {
          this.throwSuccess('Thêm mới thành công!');
          this.loadData();
          this.closeModal();
        } else {
          this.message = {
            class: 'alert dark alert-danger',
            content: res.message,
          };
        }
      },
      error => {
        this.message = {
          class: 'alert dark alert-danger',
          content: error.message,
        };
      }
    );
  }

  async editTemplate(id, payload) {
    this.templateService.update(id, payload).subscribe(
      res => {
        if (res.status == 200 && res.error == false) {
          this.throwSuccess('Cập nhật thành công!');
          this.loadData();
          this.closeModal();
        } else {
          this.message = {
            class: 'alert dark alert-danger',
            content: res.message,
          };
        }
      },
      error => {
        this.message = {
          class: 'alert dark alert-danger',
          content: error.message,
        };
      }
    );
  }

  async openConfirmDelete(type) {
    const y = confirm('Bạn có muốn xóa không?');
    if (y) {
      if (type === 'delete') {
        await this.submitDelete();
      } else {
        await this.submitDeleteAll();
      }
    }
  }

  async submitDelete() {
    this.templateService._delete(this.delete_id).subscribe(
      res => {
        if (res.status == 200 && res.error == false) {
          this.throwSuccess('Xóa thành công!');
          this.loadData();
        } else {
          this.throwError(res.message);
        }
      },
      error => {
        this.throwError(error.message);
      }
    );
  }

  async submitDeleteAll() {
    this.templateService.deleteMany({ ids: this.delete_ids }).subscribe(
      res => {
        if (res.status == 200 && res.error == false) {
          this.throwSuccess('Xóa thành công!');
          this.loadData();
          this.lstChecked = [];
        } else {
          this.throwError(res.message);
        }
      },
      error => {
        this.throwError(error.message);
      }
    );
  }

  getMyFields() {
    return this.fieldService.allField({ target: 'ticket' }).map(res => {
      if (res.status == 200 && res.error == false) {
        this.allfields = res.data;
        this.allfields.forEach(element => {
          if (element.data) {
            this.modelDisplay = [
              ...this.modelDisplay,
              {
                key: element.key,
                label: element.title,
                type: FormFieldType.Select2,
                value: this.model[`${element.key}`],
                required: false,
                disabled: false,
                width: '1/2',
                order: 4,
                options: {
                  data: element.data.map((value, index) => ({
                    id: index.toString(),
                    text: value,
                  })),
                },
              },
            ];
          }
        });
      }
    });
  }

  getAgents() {
    return this.userService.all().map(res => {
      const userList = [{ text: 'Chuyên viên đang xử lý', id: '[current-agent]' }];
      res.data.list.forEach((c: any) => {
        userList.push({
          text: c.name,
          id: c._id,
        });
      });
      this.allUser = userList;
    });
  }

  getPriorities() {
    return this.priorityService.allPriority().map(res => {
      const priorityList = [];
      res.data.forEach((c: any) => {
        priorityList.push({
          text: c.name,
          id: c.id,
        });
      });
      this.allPriority = priorityList;
    });
  }

  getStatus() {
    return this.ticketService.status().map(res => {
      const statusList = [];
      res.data.forEach((c: any) => {
        statusList.push({
          text: c.name,
          id: c.id,
        });
      });
      this.allStatus = statusList;
    });
  }

  getGroups() {
    return this.groupService.list({ limit: 500 }).map(res => {
      if (res.status == 200 && res.error == false) {
        const groupList = [];
        res.data.list.forEach(item => {
          groupList.push({
            text: item.name,
            id: item.id,
          });
        });
        this.allGroup = groupList;
      } else {
        this.allGroup = [];
      }
    });
  }

  _keyPress(event: any) {
    if (event.charCode !== 0) {
      const pattern = /[0-9]/;
      const inputChar = String.fromCharCode(event.charCode);

      if (!pattern.test(inputChar)) {
        // invalid character, prevent input
        event.preventDefault();
      }
    }
  }

  async handleAction(type: any, item?: any) {
    this.model = {};
    const config = {
      backdrop: true,
      ignoreBackdropClick: true,
      keyboard: false,
      class: 'modal-lg',
    };
    switch (type) {
      case TableAction.add:
        await this.setUpModel('add');
        this.openModal(this.templateExample, config, null, {
          modelContent: this.modelContent,
          modelDisplay: this.modelDisplay,
        });
        break;
      case TableAction.edit:
        Object.keys(item).forEach(key => {
          if (item[key] !== null && item[key] !== undefined) {
            this.model[key] = item[key];
          }
        });
        this.model.access_ids = this.parseAccessIds('get', this.model.access_ids);
        await this.setUpModel('edit');
        this.openModal(this.templateExample, config, this.model, {
          modelContent: this.modelContent,
          modelDisplay: this.modelDisplay,
        });
        break;
      case TableAction.delete:
        this.delete_id = item._id;
        await this.openConfirmDelete('delete');
        break;
      case TableAction.deleteAll:
        this.delete_ids = this.lstChecked;
        await this.openConfirmDelete('deleteAll');
        break;
    }
  }

  parseAccessIds(type, data) {
    if (!data) {
      return null;
    }
    let accessIds = [];
    if (type === 'get') {
      accessIds = data.map(d => (d.id ? d.id.toString() : d));
    } else if (type === 'submit') {
      if (this.model.access_type === AnswerTemplateType.GroupAgent) {
        data.forEach(d => {
          const group = this.allGroup.find(g => g.id == d);
          if (group) {
            accessIds.push({
              id: group.id,
              label: group.text,
            });
          }
        });
      } else if (this.model.access_type === AnswerTemplateType.Agent) {
        data.forEach(d => {
          const group = this.allUser.find(g => g.id == d);
          if (group) {
            accessIds.push({
              id: group.id,
              label: group.text,
            });
          }
        });
      }
    }
    return accessIds;
  }

  async handleSubmit(item?: any) {
    this.model = _.merge({}, this.model, item);
    if (
      !this.model.subject &&
      !this.model.intro &&
      (!this.model.follow || this.model.follow == -1) &&
      (!this.model.cc || this.model.cc == -1) &&
      (!this.model.assign || this.model.assign == -1) &&
      (!this.model.priority || this.model.priority == -1) &&
      (!this.model.status || this.model.status == -1)
    ) {
      this.message = {
        class: 'alert dark alert-danger',
        content: 'Yêu cầu chọn ít nhất 1 nội dung ticket!',
      };
      return;
    }
    let dataField = this.allfields.reduce((accumulator, value) => {
      if (!this.model[value.key]) {
        accumulator[value.key] = null;
      } else {
        accumulator[value.key] = this.model[value.key];
      }
      return accumulator;
    }, {});

    // Tạo payload kết hợp dataField với các thuộc tính khác từ this.model
    const payload = {
      ...dataField,
      name: this.model.name,
      subject: this.model.subject,
      intro: this.model.intro,
      follow: this.model.follow,
      note: this.model.note,
      cc: this.model.cc,
      assign: this.model.assign,
      priority: this.model.priority,
      status: this.model.status,
      access_type: this.model.access_type,
    };
    payload['access_ids'] = this.parseAccessIds('submit', this.model.access_ids);
    if (this.typeModal === 'add') {
      await this.addTemplate(payload);
    } else if (this.typeModal === 'edit') {
      await this.editTemplate(this.model._id, payload);
    }
  }

  async onChangeValueModel(key, item?: any) {
    this.model = _.merge({}, this.model, item);
    this.message = null;
    await this.setUpModel(this.typeModal);
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/setting/tickets/answertemplate/answer-template.component.ts